/**
 * Comparação das versões no formato do legado (`3.00.01.003`).
 *
 * <p>Comparar como texto funcionaria enquanto todos os campos tivessem a mesma largura, e falharia
 * no primeiro `3.00.01.10` publicado depois de um `3.00.01.9`. Comparar número a número não
 * depende do preenchimento com zeros.</p>
 */

/** Segmentos numéricos da versão; o que não for número vira 0 e não derruba a comparação. */
function segmentos(versao: string): number[] {
  return String(versao ?? '')
    .trim()
    .split('.')
    .map(parte => {
      const numero = Number.parseInt(parte, 10);
      return Number.isNaN(numero) ? 0 : numero;
    });
}

/**
 * Negativo se `a` for anterior a `b`, zero se forem equivalentes, positivo se for posterior.
 *
 * <p>Versões de comprimentos diferentes são comparadas até o maior dos dois, com os segmentos
 * ausentes valendo 0: `3.00.01` e `3.00.01.000` são a mesma versão.</p>
 */
export function compararVersoes(a: string, b: string): number {
  const x = segmentos(a);
  const y = segmentos(b);
  for (let i = 0; i < Math.max(x.length, y.length); i++) {
    const diferenca = (x[i] ?? 0) - (y[i] ?? 0);
    if (diferenca !== 0) {
      return diferenca;
    }
  }
  return 0;
}

/**
 * A versão em uso atende ao mínimo exigido pelo backend?
 *
 * <p>Mínimo ausente ou ilegível não bloqueia ninguém: um cabeçalho que não chegou (proxy que o
 * removeu, backend antigo que não o envia) não é motivo para tirar o usuário do sistema.</p>
 */
export function versaoAtende(versaoEmUso: string, versaoMinima: string | null | undefined): boolean {
  if (!versaoMinima || !versaoMinima.trim()) {
    return true;
  }
  return compararVersoes(versaoEmUso, versaoMinima) >= 0;
}
